import { SpeakerTest } from "../../components/speaker-test"
import { MicrophoneTest } from "../../components/microphone-test"
import { CameraTest } from "../../components/camera-test"
import { NetworkSection } from "../../components/network-section"
import "./settings.css"
import "../../componentStyle/network-diagnostic.css"

export function Settings() {
  return (
    <div className="settings-container">
      <div className="settings-grid">
        {/* Audio Container - holds both Speaker and Microphone as separate sections */}
        <h2 className="settings-title">Audio</h2>
        <div className="audio-container">
          <div className="settings-section">
            <SpeakerTest />
          </div>
          <div className="settings-section">
            <MicrophoneTest />
          </div>
        </div>

        {/* Video and Network in a row */}
        <h2 className="settings-title">Video</h2>
        <div className="settings-row">
          <div className="settings-section video-section">
            <CameraTest />
          </div>
        </div>
        <h2 className="settings-title">Network</h2>
        <div className="settings-section network-section">
          <NetworkSection />
        </div>
      </div>
    </div>
  )
}